class Cookies {
	constructor() {
		this._init()
	}
	_init() {
		const elCookies = document.querySelector('[data-cookie-policy]');
		if (elCookies) {
			if (!localStorage.getItem('give-consent-to-cookies')) {
				elCookies.classList.add('popup-message-cookies-is-visible');
				elCookies.querySelector('button').addEventListener('click', function() {
					elCookies.addEventListener('transitionend', () => {
						elCookies.remove();
					})
					localStorage.setItem('give-consent-to-cookies', true);
					elCookies.classList.remove('popup-message-cookies-is-visible');
				});
			} else {
				elCookies.remove();
			}
		}
	}
}

export default Cookies